
export function toHump(name) {
  return name.replace(/_(\w)/g, function(all, letter) {
    return letter.toUpperCase();
  });
}

/* 驼峰转换下划线*/
export function toLine(name) {
  return name.replace(/([A-Z])/g, '_$1').toLowerCase();
}


/* 驼峰转换下划线*/
export function objectToLine(name) {
  if (name instanceof Object) {
    let result = {};
    Object.keys(name).forEach((key) => {
      result[objectToLine(key)] = name[key];
    });
    return result;
  }
  return name.replace(/([A-Z])/g, '_$1').toLowerCase();
}